import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import ChatBot from './ChatBot';
import { initColorInversion } from './utils/colorInversion';
import { initNotificationSound } from './utils/notificationSound';

// Expose store to window for testing
if (process.env.NODE_ENV === 'development') {
  window.store = store;
  
  // Test HTML streaming function
  window.testHtmlStreaming = () => {
    // console.log('🧪 Testing HTML streaming...');
    
    const testMessageId = Date.now();
    const htmlChunks = [
      '<p>This is a ',
      '<strong>test</strong> of ',
      '<em>HTML streaming</em>. ',
      'It should render as HTML!</p>',
      '<ul><li>Item 1</li><li>Item 2</li></ul>'
    ];
    
    // Add initial message
    window.store.dispatch({
      type: 'chat/addMessage',
      payload: {
        id: testMessageId,
        text: '',
        isUser: false,
        timestamp: new Date().toISOString(),
        isLoading: true,
        isStreaming: true,
        isHtml: false
      }
    });
    
    let accumulatedContent = '';
    
    // Stream chunks with delay
    htmlChunks.forEach((chunk, index) => {
      setTimeout(() => {
        accumulatedContent += chunk;
        
        // Detect HTML
        const hasHtml = accumulatedContent.includes('<') && accumulatedContent.includes('>');
        
        // console.log(`📝 Chunk ${index + 1}:`, {
        //   chunk,
        //   accumulated: accumulatedContent,
        //   hasHtml
        // });
        
        window.store.dispatch({
          type: 'chat/updateStreamingMessage',
          payload: {
            id: testMessageId,
            content: accumulatedContent,
            isHtml: hasHtml,
            isStreaming: true
          }
        });
        
        // Complete on last chunk
        if (index === htmlChunks.length - 1) {
          setTimeout(() => {
            window.store.dispatch({
              type: 'chat/completeStreamingMessage',
              payload: {
                id: testMessageId,
                content: accumulatedContent,
                isHtml: hasHtml
              }
            });
            // console.log('✅ HTML streaming test completed!');
          }, 500);
        }
      }, index * 1000);
    });
  };
  
  // console.log('🔧 Development mode: window.store and window.testHtmlStreaming() available');
}

// Photos keep their real colours when the client platform inverts Aura for dark mode
initColorInversion();
// A chime when a live-chat agent replies, once the person has tapped or typed in Aura
initNotificationSound();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ChatBot />
    </Provider>
  </React.StrictMode>
); 